(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-featured-collection"] && !Shopify.designMode) return;
  try {
    
  function bindHomeCarousel(root) {
    if (!root || root.getAttribute('data-gt-arrows-bound') === 'true') return;
    var slot = root.querySelector('[data-gt-carousel-arrows]');
    var content = root.querySelector('[data-content]');
    if (!slot || !content) return;
    root.setAttribute('data-gt-arrows-bound', 'true');

    var previousLabel = root.getAttribute('data-previous-label');
    var nextLabel = root.getAttribute('data-next-label');
    var locked = false;

    function labelButtons() {
      var previous = slot.querySelector('.previous');
      var next = slot.querySelector('.next');
      if (previous && previousLabel) previous.setAttribute('aria-label', previousLabel);
      if (next && nextLabel) next.setAttribute('aria-label', nextLabel);
    }

    function moveButtons() {
      var buttons = content.querySelectorAll('.flickity-prev-next-button, .flickity-button');
      buttons.forEach(function (button) {
        if (button.parentElement !== slot) slot.appendChild(button);
      });
      labelButtons();
    }

    function equalize() {
      if (locked) return;
      var items = content.querySelectorAll('.productgrid--item');
      if (!items.length) return;
      locked = true;
      items.forEach(function (item) {
        item.style.height = 'auto';
      });
      var max = 0;
      items.forEach(function (item) {
        max = Math.max(max, item.offsetHeight);
      });
      if (max > 0) {
        items.forEach(function (item) {
          item.style.height = max + 'px';
        });
        var viewport = content.querySelector('.flickity-viewport');
        if (viewport) viewport.style.height = max + 'px';
      }
      locked = false;
    }

    moveButtons();
    window.requestAnimationFrame(function () {
      moveButtons();
      equalize();
    });
    window.setTimeout(equalize, 400);

    var observer = new MutationObserver(function () {
      moveButtons();
      window.requestAnimationFrame(equalize);
    });
    observer.observe(content, { childList: true });

    content.querySelectorAll('img').forEach(function (image) {
      if (image.complete) return;
      image.addEventListener('load', equalize, { once: true });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(equalize, 150);
    });
  }

  function bindHomeCarousels(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-gt-home-carousel]').forEach(bindHomeCarousel);
  }

  bindHomeCarousels(document);
  document.addEventListener('shopify:section:load', function (event) {
    bindHomeCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-announcement-slider"] && !Shopify.designMode) return;
  try {
    
const { Section, Carousel } = window.PxuThemeSections;

class AnnouncementSliderSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.carousel = null;
    this.resizeTimeout = null;
    this.showArrows = this.data.show_arrows;
    this.observers = []; 
    this.onMount();
  }

  onMount() {
    if (!this.data.hasSlider) return;

    this.$root.classList.remove('pxu-announcement-slider--initialized');

    const options = {
      prevNextButtons: true,
      pageDots: false,
      groupCells: false,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: this.data.auto_rotate ? this.data.rotation_speed * 1000 : false,
    };

    this.carousel = new Carousel(this.$root, options);
    this.carousel.onMount();

    setTimeout(() => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
      this.$root.classList.add('pxu-announcement-slider--initialized'); 
    }, 0);
  
    this.initEventListeners();
  }

  waitForElement(selector, callback) {
    const element = this.$root.querySelector(selector);
    
    if (element) {
      callback(element);
      return;
    }

    const observer = new MutationObserver((mutations, obs) => {
      const element = this.$root.querySelector(selector);
      if (element) {
        obs.disconnect();
        callback(element);
        this.observers = this.observers.filter(o => o !== obs); 
      }
    });

    observer.observe(this.$root, { childList: true, subtree: true });
    this.observers.push(observer); 
  }

  initEventListeners() {
    this.events.register(window, 'resize', () => {
      this.toggleButtonVisibility(false);
      clearTimeout(this.resizeTimeout);

      this.resizeTimeout = setTimeout(() => {
        this.adjustNavigationButtons();
        this.toggleButtonVisibility(this.showArrows);
      }, 200);
    });

    this.events.register(window, 'load', () => {
      this.adjustNavigationButtons();
      this.toggleButtonVisibility(this.showArrows);
    });

    this.events.register(document, 'keydown', (event) => {
      if (event.key === 'Tab') {
        this.toggleButtonVisibility(true);
      }
    });

    this.events.register(document, 'click', (event) => {
      if (this.showArrows === false && !event.target.closest('.flickity-prev-next-button')) {
        this.toggleButtonVisibility(false);
      }
    });

    this.toggleButtonVisibility(false);
  }

  toggleButtonVisibility(visible) {
    this.waitForElement('.flickity-prev-next-button', () => {
      const buttons = this.$root.querySelectorAll('.flickity-prev-next-button');
      buttons.forEach(button => {
        button.style.transition = visible ? 'opacity 0.2s ease-out' : 'none';
        button.style.opacity = visible ? '1' : '0';
        button.style.pointerEvents = visible ? 'auto' : 'none';
      });
    });
  }

  adjustNavigationButtons() {
    this.waitForElement('.flickity-prev-next-button', () => {
      const prevButton = this.$root.querySelector('.flickity-prev-next-button.previous');
      const nextButton = this.$root.querySelector('.flickity-prev-next-button.next');
      const announcements = this.$root.querySelectorAll('.pxu-announcement-slider__text');
      const viewport = window.innerWidth;
      const container = this.$root.querySelector('.pxu-section__container');

      if (!announcements.length || !container) return;

      let maxWidth = 0;
      announcements.forEach((el) => {
        const width = el.getBoundingClientRect().width;
        maxWidth = Math.max(maxWidth, width);
      });

      const containerRect = container.getBoundingClientRect();
      const minWidth = 650;
      let buttonOffset = 8;

      if (viewport >= 860) {
        const containerLeftEdge = containerRect.left;
        const containerRightEdge = viewport - containerRect.right;
        const announcementMaxWidth = maxWidth;
        const announcementLeftEdge = containerLeftEdge + (containerRect.width - announcementMaxWidth) / 2;
        const announcementRightEdge = containerRightEdge + (containerRect.width - announcementMaxWidth) / 2;

        if (maxWidth <= minWidth) {
          const leftGap = (announcementLeftEdge - containerLeftEdge) / 2;
          const rightGap = (containerRightEdge - announcementRightEdge) / 2;
          const maxOffset = Math.min(leftGap, rightGap);
          buttonOffset = maxOffset;
        }
      }

      prevButton.style.left = `${-buttonOffset}px`;
      nextButton.style.right = `${-buttonOffset}px`;
    });
  }

  onUnmount() {
    if (!this.carousel) return;
    this.carousel.onUnmount();
    this.carousel = null;
    this.events.unregisterAll();
    this.observers.forEach(observer => observer.disconnect());
    this.observers = [];
  }

  onBlockSelect(event) {
    if (!this.carousel) return;
    const $slide = event.target.parentElement;
    this.carousel.selectSlide($slide);
  }
}

document.querySelectorAll('[data-pxu-announcement-slider]').forEach(($section) => {
  Section.init($section, AnnouncementSliderSection);
});

if (Shopify.designMode) {
  window.PxuThemeSections.AnnouncementSliderSection = AnnouncementSliderSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-countdown-timer"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
class CountdownTimerSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.countdown = this.query('[data-pxu-countdown-timer-countdown]');
    this.days = this.query('[data-pxu-countdown-timer-countdown-days]');
    this.hours = this.query('[data-pxu-countdown-timer-countdown-hours]');
    this.minutes = this.query('[data-pxu-countdown-timer-countdown-minutes]');
    this.seconds = this.query('[data-pxu-countdown-timer-countdown-seconds]');
    this.dateTime = this.query('[data-pxu-countdown-timer-countdown-datetime]');
    this.targetDate = this.dateTime ? Date.parse(this.dateTime.dateTime) : null;
    this.daysInMs = 1000 * 60 * 60 * 24;
    this.hoursInMs = this.daysInMs / 24;
    this.minutesInMs = this.hoursInMs / 60;
    this.secondsInMs = this.minutesInMs / 60;
    this.timeoutId = null;
    this.isLoading = true;

    this.onMount();
  }

  onMount() {
    this.startTimer();
  }

  onUnmount() {
    this.stopTimer();
  }

  updateLoadingState() {
    this.countdown.classList.remove('pxu-countdown-timer__countdown--loading');
  }

  startTimer() {
    const interval = 1000;
    let expectedTime = Date.now() + interval;

    if (this.targetDate <= Date.now()) {
      this.updateLoadingState();
      this.handleCountDownComplete();
      return;
    }

    const countDown = () => {
      const currentDate = Date.now();
      const timeDiff = this.targetDate - currentDate;

      if (timeDiff <= 0) {
        this.stopTimer();
        this.handleCountDownComplete();
        return;
      }

      const remainingTime = this.convertTime(timeDiff);
      const drift = currentDate - expectedTime;
      expectedTime += interval;

      if (this.isLoading) this.updateLoadingState();
      this.updateDom(remainingTime);

      this.timeoutId = setTimeout(countDown, Math.max(0, interval - drift));
    };

    this.timeoutId = setTimeout(countDown, interval);
  }

  stopTimer() {
    clearTimeout(this.timeoutId);
  }

  convertTime(timeInMs) {
    const days = parseInt(timeInMs / this.daysInMs, 10);
    timeInMs -= days * this.daysInMs;

    const hours = parseInt(timeInMs / this.hoursInMs, 10);
    timeInMs -= hours * this.hoursInMs;

    const minutes = parseInt(timeInMs / this.minutesInMs, 10);
    timeInMs -= minutes * this.minutesInMs;

    const seconds = parseInt(timeInMs / this.secondsInMs, 10);

    return { days, hours, minutes, seconds };
  }

  updateDom(dateObj) {
    const { days, hours, minutes, seconds } = dateObj;
    this.days.textContent = days;
    this.hours.textContent = hours;
    this.minutes.textContent = minutes;
    this.seconds.textContent = seconds;
  }

  handleCountDownComplete() {
    this.updateDom({
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    });

    this.countdown.classList.add('pxu-countdown-timer__countdown--complete');
  }
}

document.querySelectorAll(`[data-pxu-countdown-timer]`).forEach(($section) => {
  Section.init($section, CountdownTimerSection);
});

if (Shopify.designMode) {
  window.PxuThemeSections.CountdownTimerSection = CountdownTimerSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-scrolling-text"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;
const { debounce } = window.PxuUtils;

class ScrollingTextSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.contentItems = this.$root.querySelectorAll('[data-scrolling-text-content]');

    this.onMount();
  }

  // Section lifecycle

  onMount() {
    this._initScroll();
  }

  _initScroll() {
    this.contentItems.forEach(el => {
      const textItems = el.querySelectorAll('[data-scrolling-text-content-item]');
      const width = el.offsetWidth;

      // Calculate the total width of all marquee items.
      const totalItemWidth = [...textItems].reduce((total, item) => total + item.offsetWidth, 0);

      // Calculate the number of marquee items needed to fill the container.
      const numItems = Math.ceil(width / totalItemWidth);

      // Clone and append marquee items.
      for (let i = 0; i < numItems; i++) {
        textItems.forEach(item => {
          const clone = item.cloneNode(true);
          el.appendChild(clone);
        });
      }
    });

    this._observeAnimations();
  }

  _observeAnimations() {
    // Initiate animations in viewport.
    this.observer = new IntersectionObserver(debounce(([entry]) => {
      const { isIntersecting } = entry;
      this.$root.classList.toggle('pxu-scrolling-text--is-animated', isIntersecting);
    }, 100));

    this.observer.observe(this.$root);
  }

  onUnmount(){
    this.observer.unobserve(this.$root);
  }
}

document.querySelectorAll('[data-pxu-scrolling-text]').forEach(($section) => {
  Section.init($section, ScrollingTextSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.ScrollingTextSection = ScrollingTextSection;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-video-banner"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class VideoBannerSection extends Section {
 constructor($root) {
   super($root);
   this.$root = $root;
   this.$video = this.query('.pxu-video-banner__video');
   this.id = $root.id;
   this.data = this.loadData();
   this.observer = null;

   this.onMount();
 }

 onMount() {
   this.initIntersectionObserver();
 }

 onUnmount() {
   if (this.observer) {
     this.observer.unobserve(this.$root);
   }
 }

 initIntersectionObserver() {
   this.observer = new IntersectionObserver((entries, observer) => {
     entries.forEach(entry => {
       if (entry.isIntersecting) {
         if (this.$video) {
           this.initShopifyVideo();
         }
         observer.unobserve(this.$root);
       }
     });
   }, { threshold: 0 });
   this.observer.observe(this.$root);
 }

 initShopifyVideo() {
   if (!this.$video) return;
   const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

   if(prefersReducedMotion){
    this.$video.removeAttribute('autoplay');
    this.$video.setAttribute('controls', '');
   } else {
    this.$video.play();
   }
 }
}

document.querySelectorAll('[data-pxu-video-banner]').forEach(($section) => {
 Section.init($section, VideoBannerSection);
});

if (Shopify.designMode) {
 window.PxuThemeSections.VideoBannerSection = VideoBannerSection;
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-new"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(scope) {
      var rootNode = scope || document;
      var sections = rootNode.querySelectorAll('[data-whats-new]');
      sections.forEach(setup);
    }

    function setup(root) {
      if (!root || root.dataset.ready === 'true') return;
      var track = root.querySelector('[data-track]');
      var cards = track ? Array.prototype.slice.call(track.querySelectorAll('[data-card]')) : [];
      if (!track || cards.length === 0) return;

      root.dataset.ready = 'true';

      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var dots = root.querySelector('[data-dots]');
      var count = root.querySelector('[data-count]');
      var stage = root.querySelector('.gt-whats-new__stage');
      var dotCount = -1;
      var frame = 0;

      function motion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      function gapSize() {
        var styles = window.getComputedStyle(track);
        var raw = styles.columnGap && styles.columnGap !== 'normal' ? styles.columnGap : styles.gap;
        var value = parseFloat(raw);
        return isFinite(value) ? value : 0;
      }

      function metrics() {
        var cardWidth = cards[0].getBoundingClientRect().width;
        var gap = gapSize();
        var step = cardWidth + gap;
        var visible = 1;
        if (step > 0) {
          visible = Math.max(1, Math.round((track.clientWidth + gap) / step));
        }
        visible = Math.min(visible, cards.length);
        var maxIndex = Math.max(0, cards.length - visible);
        return { step: step, visible: visible, maxIndex: maxIndex };
      }

      function currentIndex() {
        var data = metrics();
        if (data.step <= 0) return 0;
        var index = Math.round(track.scrollLeft / data.step);
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) {
          index = data.maxIndex;
        }
        return Math.min(data.maxIndex, Math.max(0, index));
      }

      function scrollToIndex(index) {
        var data = metrics();
        var target = Math.min(data.maxIndex, Math.max(0, index));
        var left = target === data.maxIndex ? track.scrollWidth - track.clientWidth : target * data.step;
        track.scrollTo({ left: left, behavior: motion() });
      }

      function placeArrows() {
        var media = root.querySelector('.gt-whats-new__media');
        if (!stage || !media) return;
        var stageRect = stage.getBoundingClientRect();
        var mediaRect = media.getBoundingClientRect();
        var top = mediaRect.top - stageRect.top + mediaRect.height / 2;
        stage.style.setProperty('--gt-wn-arrow-top', top + 'px');
      }

      function labelFor(template, values) {
        var text = template || '';
        Object.keys(values).forEach(function (key) {
          text = text.split(key).join(String(values[key]));
        });
        return text;
      }

      function render() {
        var data = metrics();
        var index = currentIndex();
        var total = cards.length;
        var start = index + 1;
        var end = Math.min(total, index + data.visible);
        root.classList.toggle('is-static', data.maxIndex === 0);
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= data.maxIndex;
        placeArrows();

        if (count) {
          if (start === end) {
            count.textContent = labelFor(root.dataset.positionLabel, {
              __CURRENT__: start,
              __TOTAL__: total
            });
          } else {
            count.textContent = labelFor(root.dataset.rangeLabel, {
              __START__: start,
              __END__: end,
              __TOTAL__: total
            });
          }
        }

        if (!dots) return;
        var needed = data.maxIndex + 1;
        if (needed !== dotCount) {
          dots.replaceChildren();
          for (var i = 0; i < needed; i += 1) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'gt-whats-new__dot';
            button.dataset.index = String(i);
            button.addEventListener('click', function (event) {
              scrollToIndex(Number(event.currentTarget.dataset.index));
            });
            dots.appendChild(button);
          }
          dotCount = needed;
        }

        Array.prototype.forEach.call(dots.children, function (button, dotIndex) {
          var dotStart = dotIndex + 1;
          var dotEnd = Math.min(total, dotIndex + data.visible);
          var active = dotIndex === index;
          if (active) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
          if (dotStart === dotEnd) {
            button.setAttribute('aria-label', labelFor(root.dataset.dotSingleLabel, { __CURRENT__: dotStart }));
          } else {
            button.setAttribute('aria-label', labelFor(root.dataset.dotLabel, { __START__: dotStart, __END__: dotEnd }));
          }
        });
      }

      function requestRender() {
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          frame = 0;
          render();
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          scrollToIndex(currentIndex() - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollToIndex(currentIndex() + 1);
        });
      }

      track.addEventListener('scroll', requestRender, { passive: true });

      var observer = new ResizeObserver(requestRender);
      observer.observe(track);

      function onBlockSelect(event) {
        var item = event.target && event.target.closest ? event.target.closest('[data-card]') : null;
        if (!item || !root.contains(item)) return;
        var index = cards.indexOf(item);
        if (index >= 0) scrollToIndex(index);
      }

      document.addEventListener('shopify:block:select', onBlockSelect);

      root._gtWnCleanup = function () {
        observer.disconnect();
        document.removeEventListener('shopify:block:select', onBlockSelect);
        if (frame) window.cancelAnimationFrame(frame);
      };

      render();
    }

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target && event.target.querySelector ? event.target.querySelector('[data-whats-new]') : null;
      if (root && root._gtWnCleanup) root._gtWnCleanup();
    });

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        boot(document);
      });
    } else {
      boot(document);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
